// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2smXS","fullView":"styles_fullView__2Qm4V"};